// alert(String( window.location))
var str = window.location.host;

// var apiUrl =
// 	str.indexOf("wenwu") > -1 ? "https://wenwu.tongren119.com/v1" : str.indexOf("tongxin") > -1 ? "https://tongxin.tongren119.com/v1" : "https://tr.tongren119.com/v1";

// // 线上测试
// var apiUrl =
// 	str.indexOf("wenwu") > -1 ? "https://wenwu.tongren119.com/v1" : str.indexOf("tongxin") > -1 ? "https://tongxin.tongren119.com/v1" : "https://wuliantest.tongren119.com/v1";
let config = {

	// 测试
	// apiUrl: apiUrl, //物联
	apiUrl:'https://pingduwenwu.tongren119.com/v1',
	apiUrltest:'https://pingduwenwu.tongren119.com/v1',

	// apiUrltest: "http://192.168.0.88:8180/v1",
	// apiUrl: "http://192.168.0.88:8180/v1",

	/*************************************************************** */

	// 开发
	// apiUrl: "http://192.168.0.88:8180/v1", //物联

	// apiUrltest: 'http://192.168.0.88:8180/v1',

	/* ************************************************************** */

	// 线上

	// apiUrl: apiUrl, //物联

	// apiUrltest: 'https://tr.tongren119.com/v1/', //物联
	// apiUrltest: 'https://wuliantest.tongren119.com/v1', //物联

	wsDevicetest: "ws://47.105.170.47:8888/ws/mqtt", //设备ws

	wsWaterPump: "ws://192.168.0.88:8888/ws/mqtt", // 水泵本地

	wsWaterPumpUrl: 'wss://wssmqtt.tongren119.com/ws/mqtt', // 水泵

	wsDeviceUrl: "ws://47.105.170.47:8888/ws/mqtt",//设备ws

	jjUrl: "https://jiejing.tongren119.com",

	jjTesturl: "http://192.168.1.112:8397",

	camraTestUrl: "http://www.qutgroup.com:13123", // 摄像头地址，

	camraUrl: "http://www.qutgroup.com:13123",

	wsUrl: "wss://wss.tongren119.com/ws/trweb", // ws

	wsUrltest: "wss://wss.tongren119.com/ws/trweb",

	camraWs: "ws://192.168.1.104:8866/live",

	noToken: [
		"https://quan.suning.com/getSysTime.do",
		"https://restapi.amap.com/v3/weather/weatherInfo",
	],
	ossConfig: {
		region: `oss-cn-qingdao`, // 默认存在根目录，可根据需求改
		accessKeySecret: "t3DV2476QaRij0B40MtaYg0H2duVQz", // AccessKeySecret 去你的阿里云上控制台上找
		accessKeyId: "LTAI4GG7y69ruW5Z5whZkpku", // AccessKeyId 去你的阿里云上控制台上找
		bucket: "zhidui-video",
	},
	host: "",
	upload: "/CRT",
	wenwu: "/wenwu",
	plan: "/wulianpic/dianzi",
	dangan: "/dangan",
};

if (process.env.NODE_ENV === "development") {
	//本地
	config.host = config.apiUrltest;
} else if (process.env.NODE_ENV === "production") {
	//线上
	config.host = config.apiUrl;
}

export default config;
